import {useEffect, useState} from "react";
import {
    Button, Card, Flex, Pagination, Typography, Space, Progress,
    message, Tag, Empty, Popconfirm, Tooltip, Descriptions
} from "antd";
import Apiurl from "../ConstURL";
import {
    DeleteOutlined, StopOutlined, DownloadOutlined,
    ClockCircleOutlined, UserOutlined, NumberOutlined,
    PictureOutlined, SafetyCertificateOutlined,
} from '@ant-design/icons';

const {Title, Text} = Typography;

const statusConfig = {
    done: {color: 'success', label: 'Выполнен'},
    running: {color: 'processing', label: 'Выполняется'},
    generate_excel: {color: 'warning', label: 'Генерация Excel'},
    wait: {color: 'default', label: 'В очереди'},
    cancelled: {color: 'error', label: 'Отменён'},
    err: {color: 'error', label: 'Ошибка'},
};

export default function Mainpage() {
    const [tasks, settasks] = useState([]);
    const [taskscount, settaskscount] = useState(0);
    const [pagenum, set_pagenum] = useState(1);

    function fetchTasks(page) {
        fetch(Apiurl + "/task/get?" + new URLSearchParams({
            token: localStorage.getItem("token"),
            skip: (page - 1) * 10,
            limit: 10
        }))
            .then(response => response.json())
            .then(data => {
                settaskscount(data.Allcount);
                settasks(data.Tasks);
            });
    }

    function handleDelete(id) {
        fetch(Apiurl + "/task/delete/" + id + "?" + new URLSearchParams({
            token: localStorage.getItem("token"),
        }))
            .then(response => response.json())
            .then(data => {
                if (data.Status) {
                    const idx = tasks.findIndex((el) => el.Id === id);
                    let newTasks = tasks.slice();
                    newTasks[idx].Deleted = true;
                    settasks(newTasks);
                    message.success("Задача удалена!");
                } else {
                    message.error("Задача не удалена!");
                }
            });
    }

    const CancelParsing = (taskid) => {
        fetch(Apiurl + "/task/cancel/" + taskid + "?" + new URLSearchParams({
            token: localStorage.getItem("token")
        }))
            .then(response => response.json())
            .then(data => {
                if (data.Status) {
                    message.success("Задача " + taskid + " отменена");
                } else {
                    message.error("Задача " + taskid + " не отменена");
                }
            });
        fetchTasks(pagenum);
    };

    const onChangePage = (page) => {
        set_pagenum(page);
        fetchTasks(page);
    };

    useEffect(() => {
        fetchTasks(pagenum);
    }, [pagenum]);

    useEffect(() => {
        const timer = setInterval(() => {
            fetch(Apiurl + "/task/get?" + new URLSearchParams({
                token: localStorage.getItem("token"),
                skip: (pagenum - 1) * 10,
                limit: 10
            }))
                .then(response => response.json())
                .then(data => {
                    settaskscount(data.Allcount);
                    settasks(data.Tasks);
                });
        }, 2500);
        return () => clearInterval(timer);
    }, [tasks, pagenum]);

    const getTaskStatus = (task) => {
        if (task.Deleted) return {color: 'error', label: 'Удалён'};
        return statusConfig[task.Task_status] || {color: 'default', label: task.Task_status};
    };

    const taskId = (task) => task.Id.split(":")[1];

    return (
        <div>
            <Flex justify="space-between" align="center" style={{marginBottom: 24}}>
                <Title level={3} style={{margin: 0}}>Задачи</Title>
                <Text type="secondary">{taskscount} всего</Text>
            </Flex>

            {tasks.length === 0 ? (
                <Empty description="Задач пока нет" style={{marginTop: 80}}/>
            ) : (
                <Space direction="vertical" size="middle" style={{width: '100%'}}>
                    {tasks.map((task) => {
                        const status = getTaskStatus(task);
                        const isDone = task.Task_status === "done";
                        const isRunning = task.Task_status === "running";
                        const isActive = isRunning || task.Task_status === "wait";
                        const isFinished = isDone || task.Task_status === "cancelled" || task.Task_status === "err";
                        const canDelete = isFinished && !task.Deleted && !task.Update_all_base;
                        const canDownload = isDone && !task.Deleted && !task.Update_all_base;

                        return (
                            <Card
                                key={task.Id}
                                className="task-card"
                                style={{borderLeft: `3px solid ${status.color === 'success' ? '#52c41a' : status.color === 'processing' ? '#a017ff' : status.color === 'warning' ? '#faad14' : status.color === 'error' ? '#ff4d4f' : '#434343'}`}}
                            >
                                <Flex justify="space-between" align="start" wrap="wrap" gap={12}>
                                    <div style={{flex: 1, minWidth: 200}}>
                                        <Flex align="center" gap={12} style={{marginBottom: 12}}>
                                            <Text strong style={{fontSize: 16}}>#{taskId(task)}</Text>
                                            <Tag color={status.color}>{status.label}</Tag>
                                            {task.Update_all_base && (
                                                <>
                                                    <Tag color="red">Сервисное задание</Tag>
                                                    {task.Update_all_base_caption && (
                                                        <Tag color="warning">{task.Update_all_base_caption}</Tag>
                                                    )}
                                                </>
                                            )}
                                        </Flex>

                                        <Descriptions size="small" column={{xs: 1, sm: 2, md: 3}} style={{marginBottom: isRunning ? 12 : 0}}>
                                            <Descriptions.Item label={<><UserOutlined/> Запустил</>}>
                                                {task.Who_started_username}
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<><NumberOutlined/> Уник. строк</>}>
                                                {task.All_id_count}
                                            </Descriptions.Item>
                                            {isRunning && (
                                                <Descriptions.Item label="Обработано">
                                                    {task.Parsed_id_count}
                                                </Descriptions.Item>
                                            )}
                                            {isDone && (
                                                <Descriptions.Item label={<><ClockCircleOutlined/> Время</>}>
                                                    {task.Time_spent} сек.
                                                </Descriptions.Item>
                                            )}
                                        </Descriptions>

                                        {isRunning && (
                                            <Progress
                                                percent={task.Percent}
                                                status="active"
                                                strokeColor="#a017ff"
                                                style={{marginTop: 4}}
                                            />
                                        )}
                                    </div>

                                    <Flex gap={8} wrap="wrap" align="start">
                                        {canDownload && (
                                            <>
                                                <Tooltip title="Скачать Excel">
                                                    <Button
                                                        type="primary"
                                                        icon={<DownloadOutlined/>}
                                                        href={Apiurl + "/task/get/excel/" + taskId(task) + "?token=" + localStorage.getItem("token")}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Excel
                                                    </Button>
                                                </Tooltip>
                                                {task.All_id_count < 5001 && (
                                                    <>
                                                        <Tooltip title="Resized фото">
                                                            <Button
                                                                icon={<PictureOutlined/>}
                                                                href={Apiurl + "/task/get/excel/resized/" + taskId(task) + "?token=" + localStorage.getItem("token")}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Resized
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title="Проверенные фото">
                                                            <Button
                                                                icon={<SafetyCertificateOutlined/>}
                                                                href={Apiurl + "/task/get/excel/photochecked/" + taskId(task) + "?token=" + localStorage.getItem("token")}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Проверенные
                                                            </Button>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {isActive && !task.Update_all_base && (
                                            <Tooltip title="Отменить парсинг">
                                                <Button
                                                    danger
                                                    icon={<StopOutlined/>}
                                                    onClick={() => CancelParsing(task.Id)}
                                                >
                                                    Отменить
                                                </Button>
                                            </Tooltip>
                                        )}

                                        {canDelete && (
                                            <Popconfirm
                                                title="Удалить задачу?"
                                                description="Это действие нельзя отменить"
                                                onConfirm={() => handleDelete(task.Id)}
                                                okText="Да"
                                                cancelText="Нет"
                                                okButtonProps={{danger: true}}
                                            >
                                                <Tooltip title="Удалить">
                                                    <Button danger type="text" icon={<DeleteOutlined/>}/>
                                                </Tooltip>
                                            </Popconfirm>
                                        )}
                                    </Flex>
                                </Flex>
                            </Card>
                        );
                    })}
                </Space>
            )}

            {taskscount > 10 && (
                <Flex justify="center" style={{marginTop: 32, paddingBottom: 32}}>
                    <Pagination
                        current={pagenum}
                        total={taskscount}
                        showSizeChanger={false}
                        onChange={onChangePage}
                    />
                </Flex>
            )}
        </div>
    );
}
